import changeCurrentLocation from 'actions/lib/change_current_location';
import WebhookEditor from 'models/location/integrations/webhook_editor';

export default class OpenNewWebhook {
  constructor(context) {
    this.context = context;
  }

  run() {
    changeCurrentLocation(this.context, WebhookEditor.create());
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/webhooks/open_new_webhook.js